import { produce } from 'immer';
import { keys, xor, isEmpty } from 'lodash/fp';
import { CLONE_PROJECT } from 'app/store/projects/types.js';
import {
    SET_DEFAULT_FLOW_MODE,
    CLEAR_SELECTION,
    COLLAPSE_ALL_GROUPS,
    CREATE_NODE_GROUP,
    DELETE_NODE_GROUP,
    EXPAND_ALL_GROUPS,
    TOGGLE_GROUP,
    TOGGLE_SELECTION,
    AREA_SELECTION,
    FROM_TO_SELECTION,
    SET_BULK_GROUP_EXPANSION
} from './types.js';

export const INITIAL_STATE = {
    defaultFlowModeByProjectId: {},
    selectedNodesByProjectId: {},
    groupExpandedStateById: {}
};

export const flowReducer = produce((draft, action) => {
    switch (action.type) {
        case SET_DEFAULT_FLOW_MODE: {
            const { mode, projectId } = action.payload;
            draft.defaultFlowModeByProjectId[projectId] = mode;
            break;
        }
        case TOGGLE_SELECTION: {
            const { projectId, nodeIds } = action.payload;
            const selection = draft.selectedNodesByProjectId[projectId];

            draft.selectedNodesByProjectId[projectId] = xor(selection, nodeIds);
            return;
        }
        case AREA_SELECTION:
        case FROM_TO_SELECTION: {
            const { nodeIds, projectId } = action.payload;

            if (!isEmpty(nodeIds) || action.type === AREA_SELECTION) {
                draft.selectedNodesByProjectId[projectId] = nodeIds;
            }

            break;
        }
        case CLEAR_SELECTION: {
            const { projectId } = action.payload;
            delete draft.selectedNodesByProjectId[projectId];
            return;
        }
        case CREATE_NODE_GROUP.SUCCEEDED: {
            const { spaceUid } = action.payload;
            delete draft.selectedNodesByProjectId[spaceUid];
            return;
        }
        case DELETE_NODE_GROUP.SUCCEEDED: {
            const { spaceUid, children } = action.payload;
            draft.selectedNodesByProjectId[spaceUid] = children;
            return;
        }
        case TOGGLE_GROUP: {
            const { assetId } = action.payload;
            draft.groupExpandedStateById[assetId] = !draft.groupExpandedStateById[assetId];
            break;
        }
        case SET_BULK_GROUP_EXPANSION: {
            const { expandedById } = action.payload;
            Object.assign(draft.groupExpandedStateById, expandedById);
            break;
        }
        case EXPAND_ALL_GROUPS: {
            action.payload.assetIds.forEach((assetId) => {
                draft.groupExpandedStateById[assetId] = true;
            });
            break;
        }
        case COLLAPSE_ALL_GROUPS: {
            action.payload.assetIds.forEach((assetId) => {
                draft.groupExpandedStateById[assetId] = false;
            });
            break;
        }
        case CLONE_PROJECT.SUCCEEDED: {
            const { from: fromProject } = action.params;
            const { groups, uid: toProject } = action.payload;

            keys(groups).forEach((from) => {
                const to = groups[from];
                draft.groupExpandedStateById[`${toProject}.${to}`] =
                    draft.groupExpandedStateById[`${fromProject}.${from}`] || false;
            });
            break;
        }
        default:
    }
}, INITIAL_STATE);
